import { render, staticRenderFns } from "./ServiceFee.vue?vue&type=template&id=16413c16&"
import script from "./ServiceFee.vue?vue&type=script&lang=js&"
export * from "./ServiceFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports